import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getLocale, htmlLangOf, usePendingLocale } from '@/shared/i18n'
import { Button } from '@/shared/ui/Button'
import { Icon } from '@/shared/ui/Icon'
import { Menu } from '@/shared/ui/Menu'
import { Popover } from '@/shared/ui/Popover'
import { useLocaleMenuGroup } from './useLocaleMenuGroup'

/**
 * Выбор языка интерфейса в шапке: русский, английский, китайский. Язык меняется без
 * перезагрузки и хранится в браузере, как тема. Кнопка показывает код текущего языка, её имя —
 * код вместе с самоназванием. Пока словарь впервые выбранного языка едет по сети, на кнопке
 * спиннер: на медленной сети иначе выбор выглядел бы проигнорированным.
 */
export function LocaleSwitch() {
  const { t } = useTranslation()
  const group = useLocaleMenuGroup()
  const pending = usePendingLocale()
  const anchorRef = useRef<HTMLButtonElement>(null)
  const [open, setOpen] = useState(false)
  const current = getLocale()

  return (
    <>
      <Button
        ref={anchorRef}
        variant="secondary"
        size="md"
        iconLeft={<Icon name="globe" size="sm" />}
        loading={pending !== null}
        aria-label={t('locale.trigger', {
          name: t(`locale.name.${current}`),
          code: t(`locale.code.${current}`),
        })}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <span lang={htmlLangOf(current)}>{t(`locale.code.${current}`)}</span>
      </Button>

      <Popover anchorRef={anchorRef} open={open} onOpenChange={setOpen} placement="bottom-end">
        <Menu label={group.label} items={group.items} autoFocus onSelect={() => setOpen(false)} />
      </Popover>
    </>
  )
}
